let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bIWCv")).then(() => parcelRequire('d6RJ6'));